/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'
import {WidgetEventsByCategory} from './widgets/WidgetEventsByCategory'
import {WidgetDiagnosticOccurrencies} from './widgets/WidgetDiagnosticOccurrencies'
import {WidgetMap} from './widgets/WidgetMap'
import {WidgetDeviceEventsComparison} from './widgets/WidgetDeviceEventsComparison'
import {WidgetEventsRecap} from './widgets/WidgetEventsRecap'
import {WidgetUserManagedEvents} from './widgets/WidgetUserManagedEvents'
import {processGet, processPatch} from '../../../services/api'
import {set} from 'date-fns'
import {ButtonType, CustomModal} from '../../parts/components/CustomModal'
import {json} from 'stream/consumers'

const DashboardPage: FC = () => {
  const intl = useIntl()
  const [layout, setLayout] = useState<any>([])
  const [tmpLayout, setTmpLayout] = useState<any>({widgets: [], days: 7})
  const [tmpWidgets, setTmpWidgets] = useState<any>([])
  const [tmpDays, setTmpDays] = useState<number>(7)
  const [days, setDays] = useState<number>(7)
  const [widgets, setWidgets] = useState<any>([])
  const modalRef = useRef<any | null>(null)
  console.log("widgets", widgets)
  const buttons: Array<ButtonType> = [
    {
      title: intl.formatMessage({id: 'GENERIC.SAVE'}),
      color: 'primary',
      action: async () => {
        console.log('Saving layout', tmpWidgets, tmpDays)
        layout.widgets = tmpWidgets
        layout.days = tmpDays
        console.log(" QUI 1")
        setLayout(layout)
        setWidgets(tmpWidgets)
        setDays(tmpDays)
        modalRef.current?.close()
        await processPatch('me/dashboard-layout', {dashboard_layout: layout})
      },
    },
  ]

  useEffect(() => {
    const fetchLayout = async () => {
      const response: any = await processGet('me')
      const layout = response.data.dashboard_layout || {widgets: [], days: 7}
      if(!response.data.dashboard_layout) {
        response.data.dashboard_layout = {widgets: [], days: 7};
      }
      console.log(" QUI 2")
      setWidgets(response.data.dashboard_layout.widgets || [])
      setDays(response.data.dashboard_layout.days || 7)
      setLayout(layout)
    }

    fetchLayout()
  }, [])

  const openModal = () => {
    console.log('TMPLayout fetched', layout)
    setTmpWidgets(layout.widgets ?? [])
    setTmpDays(layout.days ?? 7)
    setTimeout(() => {
      modalRef.current?.open()
    })
  }

  return (
    <>
      <div className='row gy-5 g-xl-8'>
        <div className='col-md-2 '>
          <button className='btn btn-primary mb-3' onClick={() => openModal()}>
            {intl.formatMessage({id: 'GENERIC.COFIG_DASHBOARD'})}
          </button>
        </div>
      </div>

      <div className='row  gy-5 g-xl-8'>
      {widgets && widgets.includes('map') ? (
          <div className='col-md-6'>
            <div className='card mb-5 mb-xl-10 card-md-stretch'>
              <div className='card-body' style={{minHeight: '400px'}}>
                <WidgetMap />
              </div>
            </div>
          </div>
        ) : null}

        
        {widgets && widgets.includes('diagnostic_occurrencies') ? (
          <div className='col-md-6'>
            <div className='card mb-5 mb-xl-10 card-md-stretch'>
              <div className='card-body' style={{minHeight: '400px'}}>
                <WidgetDiagnosticOccurrencies days={days} />
              </div>
            </div>
          </div>
        ) : null}

        
        {widgets && widgets.includes('events_by_category') ? (
          <div className='col-md-6'>
            <div className='card mb-5 mb-xl-10 card-md-stretch'>
              <div className='card-body' style={{minHeight: '400px'}}>
                <WidgetEventsByCategory days={days}  />
              </div>
            </div>
          </div>
        ) : null}

        {widgets && widgets.includes('user_managed_events') ? (
          <div className='col-md-6'>
            <div className='card mb-5 mb-xl-10 card-md-stretch'>
              <div className='card-body' style={{minHeight: '400px'}}>
                <WidgetUserManagedEvents days={days}  />
              </div>
            </div>
          </div>
        ) : null}

        {widgets && widgets.includes('device_events_comparison') ? (
          <div className='col-md-6'>
            <div className='card mb-5 mb-xl-10 card-md-stretch'>
              <div className='card-body' style={{minHeight: '400px'}}>
                <WidgetDeviceEventsComparison days={days}  />
              </div>
            </div>
          </div>
        ) : null}

        {widgets && widgets.includes('events_recap') ? (
          <div className='col-md-6'>
            <div className='card mb-5 mb-xl-10 card-md-stretch'>
              <div className='card-body' style={{minHeight: '400px'}}>
                <WidgetEventsRecap  days={days} />
              </div>
            </div>
          </div>
        ) : null}
      </div>

      <CustomModal
        ref={modalRef}
        title={intl.formatMessage({id: 'GENERIC.COFIG_DASHBOARD'})}
        show_close={true}
        buttons={buttons}
      >
        <p className='fw-bold'>{intl.formatMessage({id: 'GENERIC.SELECT_WIDGETS'})}</p>
        <label className='form-check form-check-sm form-check-custom form-check-solid me-5 mb-3'>
          <input
            className='form-check-input'
            type='checkbox'
            value='1'
            checked={tmpWidgets && tmpWidgets.includes('diagnostic_occurrencies')}
            onChange={(selectedOption) => {
              let newTmpWidgets: any = [...tmpWidgets]
              if (selectedOption.target.checked) {
                newTmpWidgets.push('diagnostic_occurrencies')
              } else {
                newTmpWidgets = newTmpWidgets.filter((item) => item !== 'diagnostic_occurrencies')
              }
              setTmpWidgets(newTmpWidgets)
            }}
          />
          <span className='form-check-label'>
            {intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_OCCURRENCIES.TITLE'})}
          </span>
        </label>
        <label className='form-check form-check-sm form-check-custom form-check-solid me-5 mb-3'>
          <input
            className='form-check-input'
            type='checkbox'
            value='1'
            checked={tmpWidgets && tmpWidgets.includes('map')}
            onChange={(selectedOption) => {
              let newTmpWidgets: any = [...tmpWidgets]
              if (selectedOption.target.checked) {
                newTmpWidgets.push('map')
              } else {
                newTmpWidgets = newTmpWidgets.filter((item) => item !== 'map')
              }

              setTmpWidgets(newTmpWidgets)
              
            }}
          />
          <span className='form-check-label'>{intl.formatMessage({id: 'GENERIC.MAP'})}</span>
        </label>
        <label className='form-check form-check-sm form-check-custom form-check-solid me-5 mb-3'>
          <input
            className='form-check-input'
            type='checkbox'
            value='1'
            checked={tmpWidgets && tmpWidgets.includes('events_by_category')}
            onChange={(selectedOption) => {
              let newTmpWidgets: any = [...tmpWidgets]
              if (selectedOption.target.checked) {
                newTmpWidgets.push('events_by_category')
              } else {
                newTmpWidgets = newTmpWidgets.filter((item) => item !== 'events_by_category')
              }
              setTmpWidgets(newTmpWidgets)
            }}
          />
          <span className='form-check-label'>
            {intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_BY_CATEGORY.TITLE'})}
          </span>
        </label>
        <label className='form-check form-check-sm form-check-custom form-check-solid me-5 mb-3'>
          <input
            className='form-check-input'
            type='checkbox'
            value='1'
            checked={tmpWidgets && tmpWidgets.includes('user_managed_events')}
            onChange={(selectedOption) => {
              let newTmpWidgets: any = [...tmpWidgets]
              if (selectedOption.target.checked) {
                newTmpWidgets.push('user_managed_events')
              } else {
                newTmpWidgets = newTmpWidgets.filter((item) => item !== 'user_managed_events')
              }
              setTmpWidgets(newTmpWidgets)
            }}
          />
          <span className='form-check-label'>
            {intl.formatMessage({id: 'MENU.OPERATION_RANKING.USER_MANAGED_EVENTS'})}
          </span>
        </label>
        <label className='form-check form-check-sm form-check-custom form-check-solid me-5 mb-3'>
          <input
            className='form-check-input'
            type='checkbox'
            value='1'
            checked={tmpWidgets && tmpWidgets.includes('device_events_comparison')}
            onChange={(selectedOption) => {
              let newTmpWidgets: any = [...tmpWidgets]
              if (selectedOption.target.checked) {
                newTmpWidgets.push('device_events_comparison')
              } else {
                newTmpWidgets = newTmpWidgets.filter((item) => item !== 'device_events_comparison')
              }
              setTmpWidgets(newTmpWidgets)
            }}
          />
          <span className='form-check-label'>
            {intl.formatMessage({id: 'REPORT_DEVICE.COMPARISON.TITLE'})}
          </span>
        </label>
        <label className='form-check form-check-sm form-check-custom form-check-solid me-5 mb-3'>
          <input
            className='form-check-input'
            type='checkbox'
            value='1'
            checked={tmpWidgets && tmpWidgets.includes('events_recap')}
            onChange={(selectedOption) => {
              let newTmpWidgets: any = [...tmpWidgets]
              if (selectedOption.target.checked) {
                newTmpWidgets.push('events_recap')
              } else {
                newTmpWidgets = newTmpWidgets.filter((item) => item !== 'events_recap')
              }
              setTmpWidgets(newTmpWidgets)
            }}
          />
          <span className='form-check-label'>
            {intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_RECAPS.TITLE'})}
          </span>
        </label>

        <p className='fw-bold mt-5'>{intl.formatMessage({id: 'GENERIC.SELECT_WIDGETS'})}</p>
        <select
          className='form-select form-select-solid'
          value={tmpDays}
          onChange={(e) => {
            setTmpDays(parseInt(e.target.value))
            //setDays(parseInt(e.target.value))
          }}
        >
          <option value={7}>
            {intl.formatMessage({id: 'GENERIC.X_GIORNI_PRECEDENTI'}).replace('{x}', '7')}
          </option>
          <option value={14}>
            {intl.formatMessage({id: 'GENERIC.X_GIORNI_PRECEDENTI'}).replace('{x}', '14')}
          </option>
          <option value={30}>
            {intl.formatMessage({id: 'GENERIC.X_GIORNI_PRECEDENTI'}).replace('{x}', '30')}
          </option>
        </select>
      </CustomModal>
    </>
  )

}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
